import React from "react";

const Checkmark = (color) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" viewBox="0 0 14 10" fill="none">
            <path d="M1.75 5L5.5 8.75L13 1.25" stroke={color.color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    )
}

export default Checkmark;